var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.06,
    height: 12.663,
    viewBox: "0 0 12.06 12.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "forward_arrow",
    "data-name": "forward arrow",
    d: "M22.184,4l5.728,5.728-5.728,5.728v-4.3H16.456V8.3h5.728Z",
    transform: "translate(-16.206 -3.396)",
    fill: "#7e84a3",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForwardArrow);
export default __webpack_public_path__ + "static/media/icon-forward-arrow.380bc9f41fc6c289db79a85c914d0c92.svg";
export { ForwardRef as ReactComponent };